
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/meet-the-team/[slug]",
      function () {
        return require("private-next-pages/about-us/meet-the-team/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/meet-the-team/[slug]"])
      });
    }
  